import React, { useState } from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, InputNumber, Modal, Upload, GetProp, UploadProps, UploadFile } from 'antd';
import { MemberService } from "./../../services/MemberService";
import { DatePickerProps } from 'antd/lib';
import { RangePickerProps } from 'antd/es/date-picker';


type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];


interface Props {
    customerLevelId: string
    onFinish: (benefits: Array<any>) => void
}

export default function CreateConfigBenefit(props: Props) {

    const [form] = Form.useForm();

    React.useEffect(() => {
        form.resetFields();
        setFileList(null)
    }, [])

    const [fileList, setFileList] = useState<any>();

    const onChange: UploadProps['onChange'] = ({ file }) => {
        setFileList(file);
    };

    const onPreview = async (file: UploadFile) => {
        let src = file.url as string;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj as FileType);
                reader.onload = () => resolve(reader.result as string);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };


    const onFinish: FormProps["onFinish"] = async (values) => {
        const formData = new FormData()
        formData.append('customer_level_id', props?.customerLevelId)
        formData.append('icon', fileList)
        formData.append('subject', values.subject)

        var res = await MemberService.saveCustomerLevelBenefitConfig(formData)
        form.resetFields();

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setFileList(null)
            props.onFinish(res?.data?.benefits);
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onOk = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        console.log('onOk: ', value);
        form.setFieldValue('expired_date', value)
    };


    return (
        <Card
            bordered={false}>
            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    subject: ''
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Icon"
                    name="icon"
                    extra="Size limit  10 MB."
                    rules={[{ required: true, message: 'Please upload icon' }]}
                >
                    <Upload
                        beforeUpload={() => false} // Prevent auto upload
                        listType="picture-card"
                        fileList={fileList ? [fileList] : []}
                        onChange={onChange}
                        onPreview={onPreview}
                        maxCount={1}
                        accept="image/*"
                    >
                        {'+ Upload'}
                    </Upload>

                </Form.Item>

                <Form.Item
                    label="Subject"
                    name="subject"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <Input />
                </Form.Item>






                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        บันทึก
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
